import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

const ProtectedRoute = ({ children, section, action }) => {
    const user = authService.getCurrentUser();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (section && action && !authService.hasPermission(section, action)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
